/*
 * @Author: guantingting
 * @Date: 2019-07-24 14:13:42
 * @LastEditors: Please set LastEditors
 */
import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import {
  PREFIX_SORDER,
  PREFIX_SCATERP_API,
  PREFIX_SPROMOTION_API,
  PREFIX_CZJCAPI_API,
  PREFIX_SOPERATION_API
} from '@/service'

const api = {
  deleteOrder: PREFIX_SORDER + 'UOrder/deleteOrder.do', // 删除订单 202006期版本加入功能

  orderDetail: PREFIX_SORDER + 'UOrder/queryAllOrderDetail.do',

  cancel: PREFIX_SORDER + 'UOrder/cancelOrder.do',
  returnOrder: PREFIX_SORDER + 'UOrder/refundOrder.do',
  returnOrderOld:
    '//forder.cekid.com/forder-web/childOrder/refundOrderForApp.do',
  useCode: PREFIX_SCATERP_API + 'caterp/writeoffForUser.do',
  reasons: `${utils.hostname('cms')}/publish/998/custServiceCancelOrder.json`,
  refundDetail: '//sasapi.czj100.com/sas-api/api/refund/detail.do',
  recommend: `${utils.hostname('cms')}/publish/999/yuer_pay.json`,
  checkOrderStatus: PREFIX_SCATERP_API + 'caterp/getBarcodeState.do',
  getGroupDetail: PREFIX_SPROMOTION_API + 'group/getGroupDetail.do',
  queryBarcodeStatus: PREFIX_SCATERP_API + 'caterp/queryBarcodeStatus.do', // 获取核销码状态  （二维码核销信息轮询）
  orderPayAfterInfo: PREFIX_SORDER + 'UOrder/queryOrderPayAfterInfo.do',
  getOrderResult: PREFIX_CZJCAPI_API + 'order/getOrderResult.do',
  getReturnList: PREFIX_SOPERATION_API + '/module/getReturnCashList.do', //获取用户买返信息
  getCmsPushNotice: '//cms.cekid.com/publish/999/push_notice.json',
  queryCanRefundTicket: PREFIX_SORDER + 'UOrder/queryCanRefundTicket.do' //携程订单可退性检查
}
export default {
  async deleteOrder({ commit }, { uid, skey, vorder_id, orderId }) {
    // 删除订单 202006期版本加入功能
    try {
      const queryStr = JSON.stringify({
        uid,
        skey,
        orderId: vorder_id || orderId
      })
      const deleteOrder = await fetch(`${api.deleteOrder}?param=${queryStr}`)
      const deleteOrderJSON = await deleteOrder.json()
      return deleteOrderJSON
    } catch (e) {
      console.log(e)
    }
  },
  async getOrderDetail(
    { commit },
    { uid, skey, orderCode, toComment = false }
  ) {
    try {
      const queryStr = JSON.stringify({
        uid,
        skey,
        orderId: orderCode
      })
      const order = await fetch(`${api.orderDetail}?param=${queryStr}`, {
        // credentials: 'include'
      })
      const orderJSON = await order.json()
      if (orderJSON.code === '1' && orderJSON.data) {
        commit('setOrder', orderJSON.data)
        if (toComment) {
          commit('setNewComment', {
            orderId: orderCode,
            spuId: orderJSON.data && orderJSON.data.spuId,
            serviceCode: orderJSON.data && orderJSON.data.serviceCode
          })
        }
      }
      return orderJSON
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async cancelOrder({ commit }, { uid, skey, vorder_id, cancel_reason }) {
    try {
      const queryStr = JSON.stringify({
        uid,
        skey,
        orderId: vorder_id,
        cancel_reason,
        refundReason: cancel_reason || '',
        refundType: cancel_reason || ''
      })
      const cancelOrder = await fetch(`${api.cancel}?param=${queryStr}`)
      const cancelOrderJSON = await cancelOrder.json()
      return cancelOrderJSON
    } catch (e) {
      console.log(e)
    }
  },
  // 退单
  async returnOrder({ commit }, { vorder_id, uid, skey, refund_reason }) {
    try {
      const queryStr = JSON.stringify({
        orderId: vorder_id,
        uid,
        skey,
        refundType: refund_reason,
        refundReason: refund_reason
      })
      const returnOrder = await fetch(`${api.returnOrder}?param=${queryStr}`)
      const returnOrderJSON = await returnOrder.json()
      return returnOrderJSON
    } catch (e) {
      console.log(e)
    }
  },
  async returnOrderOld({ commit }, { orderId, uid, skey }) {
    try {
      const queryStr = JSON.stringify({
        orderId,
        uid,
        skey
      })
      const returnOrder = await fetch(
        `${api.returnOrderOld}?orderId=${orderId}&uid=${uid}&skey=${skey}`
      )
      const returnOrderJSON = await returnOrder.json()
      return returnOrderJSON
    } catch (e) {
      console.log(e)
    }
  },
  //携程订单可退性检查
  async queryCanRefundTicket({ commit }, { orderId, uid, skey }) {
    try {
      const queryStr = queryString.stringify({
        orderId,
        uid,
        skey
      })
      const result = await fetch(`${api.queryCanRefundTicket}?${queryStr}`)
      const resultJSON = await result.json()
      return resultJSON
    } catch (e) {
      console.log(e)
    }
  },
  // 券码核销
  async useCode({ commit }, { vorderId, staff_id, uid, skey, barcode }) {
    try {
      const queryStr = queryString.stringify({
        orderId: vorderId,
        uid,
        skey,
        barcode,
        staff_id
      })
      const useCode = await fetch(`${api.useCode}?${queryStr}`)
      const useCodeJSON = await useCode.json()
      return useCodeJSON
    } catch (e) {
      console.log(e)
      throw new Error(e.message)
    }
  },
  async getReasons({ commit, state }) {
    try {
      if (state.reasons.length > 0) {
        return
      }
      const reasons = await fetch(api.reasons)
      const reasonsJson = await reasons.json()
      if (reasonsJson) {
        commit('setReason', reasonsJson.data.cancleReason)
        commit('setRefundReasons', reasonsJson.data.refundReason)
      }
      return reasonsJson
    } catch (e) {
      console.log(e)
    }
  },
  async getRefundDetail({ commit }, { uid, skey, orderId }) {
    try {
      const query = queryString.stringify({
        uid,
        skey,
        orderId
      })
      const refund_res = await fetch(`${api.refundDetail}?${query}`)
      const refundJson = await refund_res.json()
      if (refundJson.code === '1') {
        const refundData = refundJson.data
        commit('setRefundDetail', refundData)
      }
    } catch (e) {
      console.log(e)
    }
  },
  async getPaySettings({ commit }) {
    try {
      const settings = await fetch(api.recommend)
      const settingsJson = await settings.json()
      return settingsJson.data || {}
    } catch (e) {
      console.log(e)
    }
  },
  async checkOrderStatus({ commit }, { orderId, code }) {
    try {
      const query = queryString.stringify({
        orderId,
        code
      })
      const res = await fetch(`${api.checkOrderStatus}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getGroupDetail({ commit }, { groupId, uid }) {
    try {
      const query = queryString.stringify({
        groupId,
        uid
      })
      const res = await fetch(`${api.getGroupDetail}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // 获取核销码状态  （二维码核销信息轮询）
  async queryBarcodeStatus({ commit }, { orderId, uid, skey, barcode }) {
    try {
      const queryStr = queryString.stringify({
        orderId,
        uid,
        skey,
        barcode
      })
      const barcodeStatusCode = await fetch(
        `${api.queryBarcodeStatus}?${queryStr}`
      )
      const barcodeStatusJson = await barcodeStatusCode.json()
      return barcodeStatusJson
    } catch (e) {
      console.log(e)
      throw new Error(e.message)
    }
  },
  // 19.订单支付完成获取信息接口
  async queryOrderPayAfterInfo({ commit }, { payOrderId, uid, skey }) {
    try {
      const query = queryString.stringify({
        payOrderId,
        uid,
        skey
      })
      const info = await fetch(`${api.orderPayAfterInfo}?${query}`)
      const pJson = await info.json()
      return pJson.data || {}
    } catch (e) {
      console.log(e)
    }
  },
  // 19.订单支付完成获取信息接口
  async getOrderResult(
    { commit },
    { categoryId, businessId, skuId, uid, skey }
  ) {
    try {
      const query = queryString.stringify({
        categoryId,
        businessId,
        skuId,
        uid,
        skey
      })
      const info = await fetch(`${api.getOrderResult}?${query}`)
      const pJson = await info.json()
      return pJson.data
    } catch (e) {
      console.log(e)
    }
  },

  async getReturnCashList({ commit }, { orderId, uid, skey }) {
    try {
      const query = queryString.stringify({
        orderId,
        uid,
        skey
      })
      const info = await fetch(`${api.getReturnList}?${query}`)
      const pJson = await info.json()
      return pJson.data
    } catch (e) {
      console.log(e)
    }
  },

  async queryPushList({ commit }, uid) {
    try {
      const param = JSON.stringify({
        appCode: 'HZW_MALL',
        businessType: 0,
        customerId: uid,
        flag: 0
      })
      const res = await fetch('//msg.cekid.com/app/msgSwitch/queryList.do', {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        method: 'POST',
        body: `customerInfo=${param}`,
        credentials: 'include'
      })
      const json = await res.json()
      if (json.success) {
        return json.content
      } else {
        return { result: [] }
      }
    } catch (error) {
      console.log(e)
    }
  },

  async querySubscribe({ commit }, { uid, skey, sceneId, orderId }) {
    const res = await fetch(
      `https://social.cekid.com/shequn-wxsubscribe/web/c/v1/subscribe/check?uid=${uid}&scene_id=${sceneId}&skey=${skey}&unique_id=${orderId}&source=h5-dfw`
    )
    const json = await res.json()
    return json
  },

  async getOrderPushNotice({ commit }) {
    try {
      const settings = await fetch(api.getCmsPushNotice)
      const settingsJson = await settings.json()
      return settingsJson.data || {}
    } catch (e) {
      console.log(e)
    }
  }
}
